<template >
  <template
      v-if="lang"
  >
    <ul class="nav nav-tabs mb-2">
      <li
          v-for="(langItem, langIndex)  in lang"
          class="nav-item"
      >
        <a
            :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
            @click.prevent="changeTab(langIndex)"
            href="#"
        >
          <country-flag
              :country='langItem.flag'
              size="small"
          />
          {{langItem.title}}

        </a>
      </li>
    </ul>

    <template
        v-for="(langItem, langIndex)  in lang"
    >
      <div
          v-show="activeTab == langIndex"
      >
        <html-editor2
            v-if="inputObj.params && inputObj.params.is_wysiwig"
            v-model="inputModel[langIndex]"
            editor-type="segment_odstavec"
            :editor-config="inputObj.params.editor"
        />
        <textarea
            v-else
            v-model="inputModel[langIndex]"
            :id="inputObj.name + '_lang_' + langIndex"
            type="text"
            class="form-control"
        >
        </textarea>
      </div>
    </template>
    <!--
    <display-debug>
      <template #debugView>
        inputObj {{inputModel}}
      </template>
    </display-debug>
-->
  </template>
</template>
<script>


import htmlEditor2 from "@/components/content/htmlEditor_v2";
import CountryFlag from "vue-country-flag-next"
import DisplayDebug from "@/components/general/DisplayDebug.vue";

export default {
  name: "TextAreaSegment",
  components: {
    DisplayDebug,
    CountryFlag,
    htmlEditor2
  },
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": [Object],
    "formObj": Object,
    "modelValue": [String, Object],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: null,
      activeTab: null,
    }
  },
  created() {
    if(this.lang) {
      this.inputModel = {}
      for (const i in this.lang){
        if(this.activeTab === null) {
          this.activeTab = i;
        }
        //console.log('dev TextAreaSegment created obsah', i, this.inputObj.obsah)
        if(
            this.inputObj.obsah
            && typeof this.inputObj.obsah[i] != 'undefined'
        ) {
          this.inputModel[i] = this.inputObj.obsah[i];
        }else{
          this.inputModel[i] = null
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    }
  },
  watch: {
    activeLang: {
      handler() {
        this.activeTab = this.activeLang;
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        //console.log('dev WATCH TextAreaSegment inputModel',newVal, oldVal);
        if(typeof oldVal != 'undefined'){
          this.$emit('update:modelValue', newVal )
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>